import { render, staticRenderFns } from "./AssignTaskModal.vue?vue&type=template&id=c3903998&scoped=true"
import script from "./AssignTaskModal.vue?vue&type=script&lang=js"
export * from "./AssignTaskModal.vue?vue&type=script&lang=js"
import style0 from "./AssignTaskModal.vue?vue&type=style&index=0&id=c3903998&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3903998",
  null
  
)

export default component.exports